/**
 * Punto único de los assets de marca usados en las portadas de los informes PDF.
 *
 * Cliente: Generalitat de Catalunya (Departament de Territori).
 * Emissor: UTE Eix Transversal C-25 (acisa · Rubau · Romero Polo · Sorigué).
 *
 * Mecanismo: ruta pública (igual patrón que las fuentes Poppins en `/fonts/`).
 * `@react-pdf` descarga el recurso por URL al renderizar; en el navegador
 * `/report-logos/*.png` se sirve desde `public/report-logos/`.
 *
 * Formato PNG (exportado del vector EPS/SVG, RGBA transparente, ~1000 px de
 * lado largo): bordes y texto nítidos al imprimir, sin artefactos de JPEG, y
 * pesa poco (~30-60 KB). `@react-pdf` solo embebe raster JPEG/PNG (no SVG/EPS).
 *
 * OFFLINE (PWA): cubierto. `vite.config.js` → workbox
 * `globPatterns: ['**\/*.{...,png,...}']` (tope 10 MB) precachea los `.png` de
 * `dist/report-logos/` en el service worker, así que los logos también salen
 * sin conexión. (Requiere un build/deploy con los ficheros ya presentes.)
 */
export const LOGO_GENERALITAT = '/report-logos/generalitat.png';
export const LOGO_UTE = '/report-logos/ute-c25.png';
